import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { SortingValue } from 'ha/types/SearchFilters';
import { track } from 'ha/modules/Analytics/actions';

import { onChangeFilters } from '../actions';
import { getCurrentSorting } from '../selectors';

const useSorting = () => {
  const { T } = useIntl();

  const currentSorting = useSelector(getCurrentSorting);

  const dispatch = useDispatch();

  const onOpen = useCallback(() => {
    dispatch(track('Select search sort'));
  }, []);

  const onChange = useCallback((value: SortingValue) => {
    dispatch(track('Search sort applied', { sortType: value }));
    dispatch(onChangeFilters({ sorting: value }));
  }, []);

  const options = [
    { key: T('Best match'), value: SortingValue.BestMatch },
    { key: T('Most recent'), value: SortingValue.MostRecent },
    { key: T('Lowest price'), value: SortingValue.LowToHigh },
    { key: T('Highest price'), value: SortingValue.HighToLow },
  ];

  return {
    currentSorting,
    options,
    onChange,
    onOpen,
  };
};

export default useSorting;
